import React, { useEffect, useState } from "react";
import './VersionPopup.css';
import CrossIcon from "../../assets/images/cross.svg";
import { getSoftwareVersion } from "../../api/password";

const VersionPopup = ({ onClose }) => {
  const [version, setVersion] = useState({});

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await getSoftwareVersion();
        setVersion(response);
      } catch (error) {
        console.error('Error fetching version:', error);
      }
    };
    fetchVersion();
  }, []); 

  return (
    <div className="version-popup-container" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className='top'>
          <h2 className="popup-title">Software Release Version</h2>
        </div>
        <img src={CrossIcon} className='close-button' onClick={onClose} alt="Close" />
        <div className='popup-content-values'>
          <p className="popup-message">Version Number:<span className="popup-data" >{version && version.versionNumber}</span></p>
          <p className="popup-message">LLM: <span className="popup-data" >{version && version.llm}</span></p>
          <p className="popup-message">Release Date: <span className="popup-data" >{new Date(version && version.releaseDate).toLocaleDateString()}</span></p>
          <p className="popup-message">AI Role Model: <span className="popup-data" >{version && version.llmAiModel}</span></p>
        </div>
      </div>
    </div>
  );
};

export default VersionPopup;